"use strict";
module.exports = require("./FilterComponent");
